import {  ChangeDetectorRef, Component, Input,  OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FlexService } from '../../../services/flex.service';
import { SpecialService } from '../../../services/specialop.service';
import { CommonOffer } from '../../../models/offers/CommonOffer';
import { HotelItem } from '@app/models/hotels/HotelItem';

@Component({
    selector: 'app-offerpackspecinfo',
    templateUrl: './offerpackspecinfo.component.html',
    styleUrls: ['./offerpackspecinfo.component.scss'],
    standalone: false
})
export class OfferpackspecinfoComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    @Input() offer: CommonOffer;
    @Input() hotel: HotelItem;
    @Input() mode: string;
    kostenlosStorno: string = '';
    kostenlosStornoT: string = '';
    kostenlosStornobis: Date;
    showFlex: boolean = false;
    specials = [];
    constructor (
        private flexService: FlexService,
        private specialService: SpecialService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit (): void {
        this.checkServiceCodes();
        this.checkSpecials();
    }

    
    ngOnDestroy (): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async checkSpecials () {
        this.specialService.getSpecialOp$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(tours => {
            if (tours?.length > 0) {
                const now = new Date();
                const startDate = this.offer?.travelDate?.fromDate ? new Date(this.offer.travelDate?.fromDate) : new Date();
                for (let i = 0; i < tours.length; i++) {
                    for (let s = 0; s < tours[i]?.specials?.specials?.length; s++) {
                        const spec = tours[i].specials?.specials[s];
                        if (
                            now >= new Date(spec?.bookinkzeitraumvon) &&
                            (
                                now <= new Date(spec?.bookinkzeitraumbis) ||
                                !spec?.bookinkzeitraumbis
                            ) &&
                            startDate >= new Date(spec?.reisezeitraumvon) &&
                            (
                                startDate <= new Date(spec?.reisezeitraumbis) ||
                                !spec?.bookinkzeitraumbis
                            )
                        ) {
                            if (this.offer?.tourOperator?.code === tours[i].code) {
                                if (spec?.travelType === this.mode || spec?.travelType === 'all') {
                                    this.specials.push({
                                        name: spec.name,
                                        tooltip: spec.text
                                    });
                                }
                            }
                        }
                    }
                }
            }
            this.cdr.markForCheck();
        });
    }

    async checkServiceCodes () {
        this.kostenlosStornoT = '';
        this.kostenlosStorno = 'Kostenfreies Storno bis ';

        this.flexService.getFlexsOp$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(tourOpertaors => {
            if (tourOpertaors?.length > 0) {
                const now = new Date();
                const startDate = this.offer?.travelDate?.fromDate ? new Date(this.offer.travelDate?.fromDate) : new Date();
                for (let j = 0; j < tourOpertaors.length; j++) {
                    if (
                        now >= new Date(tourOpertaors[j].toma?.bookinkzeitraumvon) &&
                        (
                            now <= new Date(tourOpertaors[j].toma?.bookinkzeitraumbis) ||
                            !tourOpertaors[j].toma?.bookinkzeitraumbis
                        ) &&
                        startDate >= new Date(tourOpertaors[j].toma?.reisezeitraumvon) &&
                        (
                            startDate <= new Date(tourOpertaors[j].toma?.reisezeitraumbis) ||
                            !tourOpertaors[j].toma?.bookinkzeitraumbis
                        )

                    ) {
                        if (tourOpertaors[j]?.toma?.actions?.length > 0 && tourOpertaors[j].code === this.offer?.tourOperator?.code) {
                            let index = -1;
                            let mprc = this.offer?.totalPrice?.value ? Number(this.offer?.totalPrice?.value) : 0;
                            let minIntervale = Number.MAX_VALUE;
                            for (let a = 0; a < tourOpertaors[j]?.toma?.actions.length; a++) {
                                if (this.mode === tourOpertaors[j].toma.actions[a].travelType ||
                                    tourOpertaors[j]?.toma?.actions[a].travelType === 'beides') {
                                    if (tourOpertaors[j].toma.actions[a].properson) {
                                        mprc = this.offer?.personPrice?.value ? Number(this.offer?.personPrice?.value) : 0;
                                    }
                                    tourOpertaors[j].toma.actions[a].fromPrice = tourOpertaors[j]?.toma?.actions[a].fromPrice ? String(tourOpertaors[j].toma.actions[a].fromPrice)?.trim() : null;
                                    tourOpertaors[j].toma.actions[a].toPrice = tourOpertaors[j]?.toma?.actions[a].toPrice ? String(tourOpertaors[j].toma.actions[a].toPrice)?.trim() : null;

                                    let traveldategreaterbool = true;
                                    const traveldategreaterdate = tourOpertaors[j]?.toma?.actions[a].traveldategreater;
                                    if (traveldategreaterdate?.length > 0) {
                                        const dif = (startDate.getTime() - Date.now()) / (1000 * 3600 * 24);
                                        traveldategreaterbool = dif > Number(traveldategreaterdate)
                                    }

                                    if (traveldategreaterbool && !isNaN(Number(tourOpertaors[j]?.toma?.actions[a].fromPrice)) && !isNaN(Number(tourOpertaors[j]?.toma?.actions[a].toPrice))) {
                                        if ((tourOpertaors[j]?.toma?.actions[a].toPrice === null || tourOpertaors[j]?.toma?.actions[a].toPrice === '') && mprc >= Number(tourOpertaors[j]?.toma?.actions[a].fromPrice)) {
                                            minIntervale = 0;
                                            index = a;
                                        } else if (mprc < Number(tourOpertaors[j]?.toma?.actions[a].toPrice) &&
                                                    minIntervale > Number(tourOpertaors[j]?.toma?.actions[a].toPrice)) {
                                            minIntervale = Number(tourOpertaors[j]?.toma?.actions[a].toPrice);
                                            index = a;
                                        }
                                    }
                                }
                            }

                            if (index >= 0) {
                                const tmpd = tourOpertaors[j]?.toma?.actions[index]?.today;
                                const fromday = tourOpertaors[j]?.toma?.actions[index]?.fromday;
                                if (fromday?.length > 0) {
                                    const date = new Date();
                                    this.kostenlosStornobis = new Date(date.setDate(date.getDate() + Number(fromday)));
                                } else {
                                    const date = new Date(this.offer?.travelDate.fromDate);
                                    this.kostenlosStornobis = new Date(date.setDate(date.getDate() - Number(tmpd)));
                                }
                                if (this.kostenlosStornobis > new Date()) {
                                    this.showFlex = true;
                                    this.kostenlosStornoT = tourOpertaors[j]?.toma?.actions[index].text;
                                    if (tourOpertaors[j]?.toma?.actions[index]?.flexType !== 'kostenlos') {
                                        this.kostenlosStorno = 'Günstig stornieren bis ';
                                    }
                                }
                            }
                            j = tourOpertaors.length;
                        }
                    }
                }
            }
            this.cdr.markForCheck();
        });
    }
}
